import { createSlice } from "@reduxjs/toolkit";
import { updateDoctorPersonalInfo } from "../../reducer/doctorPersonal/updateDoctorPersonalInfoReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const doctorPersonalInfoSlice = createSlice({
  name: "doctorPersonalInfo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateDoctorPersonalInfo.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateDoctorPersonalInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(updateDoctorPersonalInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default doctorPersonalInfoSlice.reducer;
